import { render } from "./AdminSidebarManualView.vue?vue&type=template&id=18afe761&scoped=true"
import script from "./AdminSidebarManualView.vue?vue&type=script&lang=js"
export * from "./AdminSidebarManualView.vue?vue&type=script&lang=js"

import "./AdminSidebarManualView.vue?vue&type=style&index=0&id=18afe761&scoped=true&lang=scss"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18afe761"]])

export default __exports__